import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/estetik-islemlerde-para-iadesi-mumkun-mu/page.tsx");
